'use client';
import { useState } from 'react';
import { submitWaitlist } from '../services/waitlist';
import { FieldGroup } from '../components/field';
import { Button } from '../components/button';

export default function CTASection() {
  const [firstName, setFirstName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [notice, setNotice] = useState<{ type: 'success' | 'error'; message: string } | null>(null)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault()
    if (isSubmitting) return
    setNotice(null)
    setIsSubmitting(true)
    const result = await submitWaitlist({ name: firstName, email })
    setIsSubmitting(false)
    if (result.ok) {
      setNotice({ type: 'success', message: "You're on the list. We'll be in touch." })
      setFirstName('')
      setEmail('')
    } else {
      setNotice({ type: 'error', message: result.message })
    }
  }

  return (
    <section className="w-full px-[20px] sm:px-[40px] md:px-[49px] lg:px-[98px] max-lg:mt-2 max-[380px]:mt-1.5 lg:mt-[32px] lg:sm:mt-[48px] lg:md:mt-[64px] max-[380px]:px-4">
      <div className="w-full max-w-[621px] sm:max-w-[931px] md:max-w-[1242px] mx-auto">
        <div className="relative rounded-[20px] bg-prople-200 overflow-hidden max-[380px]:rounded-[14px]">
          <div className="relative rounded-16 overflow-hidden max-[380px]:rounded-12">
            <div 
              className="relative bg-cover bg-top"
              style={{ backgroundImage: "url('/images/img_vector_indigo_50_404x1236.png')" }}
            >
              <div 
                className="relative bg-cover bg-top"
                style={{ backgroundImage: "url('/images/img_geminigeneratedimagexv8nlbxv8nlbxv8n_1.png')" }}
              >
                <div className="relative bg-black/[0.48] rounded-[20px] px-[28px] sm:px-[42px] md:px-[56px] py-[39px] sm:py-[58px] md:py-[78px] max-[380px]:rounded-[14px] max-[380px]:px-5 max-[380px]:py-7">
                  <div className="flex flex-col gap-[4px] sm:gap-[5px] md:gap-[6px] items-center max-[380px]:gap-3">
                    <h2 className="ds-text-title-2xl text-center text-white max-w-full sm:max-w-[500px] md:max-w-[548px] max-[380px]:ds-text-title-xl lg:ds-text-title-5xl">
                      Join the future of <br className="max-lg:hidden" />real estate investment
                    </h2>

                    <form
                      onSubmit={(e) => void handleSubmit(e)}
                      className="flex w-full max-w-[468px] flex-col items-center gap-2 max-[380px]:gap-1.5"
                    >
                      <FieldGroup
                        variant="dark"
                        stacked
                        className="max-w-[468px] shadow-[0px_2px_6px_var(--ds-gray-400)] sm:h-[56px] sm:shadow-[0px_3px_9px_var(--ds-gray-400)] md:shadow-[0px_4px_12px_var(--ds-gray-400)] max-[380px]:rounded-10"
                        fields={[
                          {
                            key: 'firstName',
                            type: 'text',
                            placeholder: 'First name',
                            value: firstName,
                            onChange: (e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value),
                            className: 'h-[50px] px-4 sm:h-full max-[380px]:h-[44px] max-[380px]:px-2.5',
                          },
                          {
                            key: 'email',
                            type: 'email',
                            placeholder: 'Email address',
                            value: email,
                            onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value),
                            className: 'h-[50px] px-4 sm:h-full max-[380px]:h-[44px] max-[380px]:px-2.5',
                          },
                        ]}
                      />

                      <Button type="submit" disabled={isSubmitting} className="max-w-[468px]">
                        {isSubmitting ? '…' : 'Join waitlist'}
                      </Button>
                      {notice ? (
                        <p
                          role="status"
                          className={`text-center ds-text-base-medium ${
                            notice.type === 'success' ? 'text-white' : 'text-red-200'
                          }`}
                        >
                          {notice.message}
                        </p>
                      ) : null}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}